import queries from '@apis/queries';
import { TermDisplayContext } from '@models/term/termCategory';
import { useQuery } from '@tanstack/react-query';

function useTermCategories(displayContext: TermDisplayContext) {
  const { data } = useQuery(queries.termCategories.list(displayContext));
  return data?.categories || [];
}

export default useTermCategories;
